export const pagesEn = {
  calendarPage: {
    title: "📅 Field Calendar",
    subtitle: "Manage your agricultural reminders and scheduled tasks",
    fieldCalendar: "Field Calendar & Reminders",
    newReminder: "New Reminder",
    createFieldReminder: "Create Field Reminder",
    reminderType: "Type",
    reminderIrrigation: "Irrigation",
    reminderFertilization: "Fertilization",
    reminderTreatment: "Treatment",
    reminderHarvest: "Harvest",
    reminderInspection: "Inspection",
    reminderCustom: "Custom",
    reminderTitle: "Title",
    reminderTitlePlaceholder: "e.g., Apply irrigation",
    reminderDescription: "Description",
    reminderDescPlaceholder: "Additional details...",
    reminderPriority: "Priority",
    priorityLow: "Low",
    priorityMedium: "Medium",
    priorityHigh: "High",
    priorityUrgent: "Urgent",
    scheduledDate: "Scheduled Date",
    createReminder: "Create Reminder",
    overdue: "Overdue",
    upcoming: "Upcoming",
    completed: "Completed",
    noRemindersYet: "No reminders yet",
    createFirstReminder: "Create your first reminder to get started",
    autoGenerated: "Auto-generated",
    reminderCreated: "Reminder created successfully",
    reminderCreateFailed: "Failed to create reminder",
    reminderCompleted: "Reminder completed",
    reminderIncomplete: "Reminder marked as incomplete",
    reminderUpdateFailed: "Failed to update reminder",
    reminderDeleted: "Reminder deleted",
    reminderDeleteFailed: "Failed to delete reminder",
    loadFailed: "Failed to load reminders"
  },
  fireDetectionPage: {
    title: "Fire-Risk Monitoring (Satellite-Derived)",
    subtitle: "Satellite-derived fire-risk alerts — NASA FIRMS hotspot monitoring + Sentinel-2 burned-area analysis. Not an emergency service.",
    nasaFirms: "NASA FIRMS (VIIRS)",
    realTimeDetection: "Near-real-time satellite hotspot signals (VIIRS, ~3–6h latency)",
    dataLatency: "3-4 hour data latency",
    spatialRes: "375m spatial resolution",
    globalCoverage: "Global coverage (SNPP + NOAA-20)",
    sentinel2Swir: "Sentinel-2 SWIR Analysis",
    postFireMapping: "Post-fire burned area mapping",
    resolution20m: "20m resolution (SWIR bands)",
    dnbrSeverity: "dNBR burn severity classification",
    recoveryEstimation: "Recovery time estimation",
    selectParcel: "Select Parcel",
    selectParcelDesc: "Choose a parcel to check satellite-derived fire-risk signals within a 50km radius",
    noParcels: "No parcels found. Please add a parcel first to use fire-risk monitoring.",
    // Panel translations
    activeFireAlerts: "Satellite Hotspot Alerts",
    riskLabel: "{{level}} Risk",
    firesCountAway: "{{count}} hotspot signal(s) • {{distance}}km away",
    dismiss: "Dismiss",
    smsSent: "SMS Sent",
    panelTitle: "Fire-Risk Monitoring (Satellite-Derived)",
    panelSubtitle: "Automatic satellite hotspot check every 4 hours using NASA FIRMS + Sentinel-2 burned-area analysis",
    alertSettings: "Alert Settings",
    hideSettings: "Hide Settings",
    automaticAlerts: "Automatic Alerts",
    automaticAlertsDesc: "Check every 4 hours automatically",
    smsNotifications: "SMS Notifications",
    smsNotificationsDesc: "Receive SMS when a satellite hotspot is detected near your parcel",
    phoneLabel: "Phone Number (with country code)",
    minRiskLevel: "Minimum Risk Level",
    criticalOnly: "Critical only",
    highCritical: "High + Critical",
    moderatePlus: "Moderate+",
    allLevels: "All levels",
    detectionRadius: "Detection Radius (km)",
    saveSettings: "Save Settings",
    saving: "Saving...",
    settingsSaved: "Settings Saved",
    settingsSavedDesc: "Your fire-risk alert settings have been updated",
    settingsSaveError: "Could not save settings",
    alertDismissed: "Alert dismissed",
    autoMonitoring: "Automatic Monitoring:",
    autoMonitoringEnabled: "System checks all parcels every 4 hours. Alerts enabled for {{level}}+ risk levels.",
    autoMonitoringDisabled: "System checks all parcels every 4 hours. Automatic alerts are currently disabled.",
    smsActive: "SMS notifications active.",
    parcelLabel: "Parcel: {{name}}",
    radiusLabel: "Radius: {{radius}} km",
    scanningFires: "Scanning for satellite hotspot signals...",
    manualCheckNow: "Manual Check Now",
    currentRiskLevel: "Current Risk Level",
    activeFiresDetected: "Satellite Hotspots Detected ({{count}}) — Requires Validation",
    kmAway: "{{distance}} km away",
    confidence: "Confidence: {{value}}",
    fireLocationMap: "Satellite Hotspot Location Map",
    fireLocationMapDesc: "Your parcel (green) and satellite hotspot signals (red/orange) within {{radius}} km radius",
    burnedAreaAnalysis: "Burned Area Analysis (Sentinel-2)",
    severity: "Severity",
    affectedArea: "Affected Area",
    dnbrIndex: "dNBR Index",
    estRecovery: "Est. Recovery",
    days: "{{count}} days",
    recommendations: "Recommendations",
    dataSources: "Data sources: {{sources}}",
    activeFiresDetectedToast: "⚠️ Satellite Hotspots Detected — Requires Validation",
    activeFiresDetectedDesc: "{{count}} satellite hotspot signal(s) within {{radius}}km of your parcel. Not a substitute for official fire alerts.",
    noActiveFiresToast: "No Hotspot Signals",
    noActiveFiresDesc: "No satellite hotspot signals near your parcel",
    detectionError: "Monitoring Error",
    detectionErrorDesc: "Could not complete satellite hotspot check",
    experimentalPropagation: "Experimental fire propagation simulation",
    experimentalPropagationDesc: "Not calibrated — for research use only",
    openPropagation: "Open simulation →",
    disclaimer: "Satellite-derived fire-risk alerts are not an emergency service and are not a substitute for official fire alerts or emergency guidance.",
    hotspotDisclaimerShort: "Possible fire-related hotspot signal · Requires validation · Not an emergency service"
  },
  seasonsPage: {
    title: "Crop Seasons",
    subtitle: "Track and compare your crop seasons across all parcels",
    filterByParcel: "Filter by parcel",
    allParcels: "All Parcels",
    newSeason: "New Season",
    activeSeasons: "Active Seasons",
    completedSeasons: "Completed Seasons",
    avgYield: "Avg. Yield",
    waterEfficiency: "Water Efficiency",
    active: "Active",
    historical: "Historical",
    all: "All",
    noActiveSeasons: "No Active Seasons",
    noActiveSeasonsDesc: "Start tracking your first crop season to unlock yield comparisons and water efficiency metrics.",
    createSeason: "Create Season",
    noCompletedSeasons: "No Completed Seasons Yet",
    noCompletedSeasonsDesc: "Historical data will appear here once you complete your first season.",
    noSeasonsFound: "No Seasons Found",
    noSeasonsFoundDesc: "Create your first crop season to start tracking.",
    viewDetails: "View Details",
    harvested: "Harvested",
    cancelled: "Cancelled",
    planning: "Planning"
  },
  newSeasonDialog: {
    title: "New Crop Season",
    description: "Register a new season to start tracking yield, water usage, and harvest.",
    cropType: "Crop Type",
    selectCrop: "Select crop",
    variety: "Variety (optional)",
    varietyPlaceholder: "E.g., Arbequina, Tempranillo...",
    plantingDate: "Planting Date",
    expectedHarvest: "Expected Harvest (optional)",
    selectDate: "Select date",
    notes: "Notes (optional)",
    notesPlaceholder: "Observations about planting, soil conditions, etc.",
    cancel: "Cancel",
    create: "Create Season",
    creating: "Creating..."
  },
  cropSeasonManager: {
    activeSeason: "Active Season",
    manageCycle: "Manage your current crop cycle",
    newSeason: "New Season",
    crop: "Crop",
    plantingDate: "Planting Date",
    expectedHarvest: "Expected Harvest",
    notSet: "Not set",
    status: "Status",
    irrigations: "Irrigations",
    waterUsed: "Water Used",
    rainfallAccum: "Rainfall Accum.",
    recordHarvest: "Record Harvest",
    cancel: "Cancel",
    noActiveSeason: "No active season. Start a new season to begin tracking your crop.",
    startNewSeason: "Start New Season",
    history: "History",
    comparison: "Comparison",
    previousSeasons: "Previous Seasons",
    historicalForParcel: "Historical seasons for this parcel",
    period: "Period",
    yield: "Yield",
    totalWater: "Total Water",
    efficiency: "Efficiency",
    quality: "Quality",
    notRecorded: "Not recorded",
    noPreviousSeasons: "No previous seasons recorded",
    overdueBy: "Overdue by {{days}} days",
    today: "Today!",
    daysRemaining: "{{days}} days remaining",
    statusActive: "Active",
    statusHarvested: "Harvested",
    statusCancelled: "Cancelled",
    statusPlanning: "Planning"
  },
  supportTicketsPage: {
    title: "Support Tickets",
    subtitle: "Technical support with 48-hour response time",
    newTicket: "New Ticket",
    cancel: "Cancel",
    createTicket: "Create Support Ticket",
    teamResponds: "Our team will respond within 48 hours",
    category: "Category",
    priority: "Priority",
    subject: "Subject",
    subjectPlaceholder: "Brief description of the issue",
    description: "Description",
    descriptionPlaceholder: "Detailed description of your issue or request",
    submit: "Submit Ticket",
    creating: "Creating...",
    fillAll: "Please fill in all required fields",
    ticketCreated: "Ticket Created",
    willRespond: "Our team will respond within 48 hours",
    noTicketsYet: "No support tickets yet. Create one if you need assistance.",
    responseFrom: "Response from Support Team:",
    resolved: "Resolved",
    statusOpen: "Open",
    statusInProgress: "In Progress",
    statusResolved: "Resolved",
    catTechnical: "Technical Issue",
    catBilling: "Billing",
    catFeature: "Feature Request",
    catData: "Data Quality",
    catAccount: "Account",
    prioLow: "Low",
    prioMedium: "Medium",
    prioHigh: "High",
    prioUrgent: "Urgent",
    linkManual: "User Manual",
    linkManualDesc: "Complete platform guide",
    linkLearning: "Learning Hub — Coming soon",
    linkLearningDesc: "Tutorials and quizzes will be available in a future update",
    linkDataSources: "Data Sources",
    linkDataSourcesDesc: "Where our data comes from",
    linkEmail: "Contact by email"
  },
  groundTruthPage: {
    title: "Ground Truth Validation",
    subtitle: "Compare satellite remote sensing data with in-situ field measurements for research validation",
    academicBadge: "🎓 Academic Tool",
    tabComparison: "Satellite vs Ground",
    tabObservations: "Field Observations",
    tabMetrics: "Validation Metrics",
    config: "Analysis Configuration",
    configDesc: "Select parcel and date range for validation",
    parcel: "Parcel",
    selectParcel: "Select parcel",
    startDate: "Start Date",
    endDate: "End Date",
    comparisonType: "Comparison Type",
    allParameters: "All Parameters",
    ndviOnly: "NDVI Only",
    soilMoistureOnly: "Soil Moisture Only",
    runAnalysis: "Run Validation Analysis",
    analyzing: "Analyzing...",
    selectParcelError: "Please select a parcel",
    analysisComplete: "Analysis Complete",
    comparedPoints: "Compared {{n}} data points",
    satelliteRecords: "Satellite Records",
    groundTruthRecords: "Ground Truth Measurements",
    validComparisons: "Valid Comparisons",
    dataQuality: "Data Quality",
    ndviStats: "NDVI Validation Statistics",
    exportData: "Export Data",
    rSquared: "R² Correlation",
    rmse: "RMSE",
    avgDiff: "Avg Difference",
    sampleSize: "Sample Size",
    methodology: "📚 Methodology Notes",
    method1: "• Correlation analysis performed using Pearson's R² coefficient",
    method2: "• Temporal matching: ±3 days window between satellite and ground measurements",
    method3: "• RMSE (Root Mean Square Error) calculated for accuracy assessment",
    method4: "• Quality thresholds: Excellent (R²>0.8), Good (0.6-0.8), Fair (0.4-0.6), Poor (<0.4)",
    exportComplete: "Export Complete",
    exportSuccess: "Academic format data exported successfully"
  },
  cropSeasonsPage: {
    activeSeason: "Active Season",
    manageCycle: "Manage your current crop cycle",
    newSeason: "New Season",
    startNewSeason: "Start New Season",
    noActive: "No active season. Start a new season to begin tracking your crop.",
    crop: "Crop",
    plantingDate: "Planting Date",
    expectedHarvest: "Expected Harvest",
    notSet: "Not set",
    status: "Status",
    overdueBy: "Overdue by {{n}} days",
    today: "Today!",
    daysRemaining: "{{n}} days remaining",
    irrigations: "Irrigations",
    waterUsed: "Water Used",
    rainfallAccum: "Rainfall Accum.",
    recordHarvest: "Record Harvest",
    cancel: "Cancel",
    statusActive: "Active",
    statusHarvested: "Harvested",
    statusCancelled: "Cancelled",
    statusPlanning: "Planning",
    history: "History",
    comparison: "Comparison",
    previousSeasons: "Previous Seasons",
    historicalDesc: "Historical seasons for this parcel",
    period: "Period",
    yieldLabel: "Yield",
    totalWater: "Total Water",
    efficiency: "Efficiency",
    quality: "Quality",
    notRecorded: "Not recorded",
    noPrevious: "No previous seasons recorded"
  },
  riskAnalysisMlPage: {
    title: "ML Risk Analysis",
    aiPowered: "AI Powered",
    subtitle: "Intelligent prediction with smart caching + real historical data",
    aiCardTitle: "AI-Powered Risk Analysis",
    aiCardSubtitle: "Intelligent analysis with 7-day cache + rate limit of 10 predictions/day",
    active: "Active",
    cache7days: "Cache: 7 days",
    limit10: "Limit: 10 predictions/day",
    selectTitle: "Select Parcel or Location",
    selectDesc: "Select an existing parcel or manually enter the province and crop",
    parcel: "Parcel",
    selectParcelPlaceholder: "Select parcel...",
    manualEntry: "📝 Manual entry",
    province: "Province *",
    selectProvince: "Select province...",
    crop: "Crop *",
    selectCrop: "Select crop...",
    condition: "Condition",
    rainfed: "Rainfed",
    irrigated: "Irrigated",
    analyze: "Analyze Risk",
    analyzing: "Analyzing...",
    aiPredictionTitle: "AI-Powered Prediction",
    aiPredictionDesc: "The model sends aggregated historical data to AI with phenological stage context, seasonal risks, and yield statistics. 7-day cache reduces AI costs by 90%.",
    badgeRealData: "100% Real Data",
    badgeGenAI: "Generative AI",
    badge7Cache: "7-Day Cache",
    badgePdf: "PDF Export"
  },
  fieldNotebookPage: {
    backToDashboard: "Back to Dashboard",
    parcelNotProvided: "Parcel ID not provided",
    parcelNotFound: "Parcel not found",
    failedToLoad: "Failed to load parcel"
  },
  fieldNotebook: {
    title: "Field Notebooks",
    subtitle: "Digital agricultural activity logs for all your parcels",
    subtitleTrack: "Track and validate agricultural activities across all your parcels",
    noParcelsFound: "No Parcels Found",
    noParcelsDesc: "You need to add parcels before you can start recording field activities.",
    addFirstParcel: "Add Your First Parcel",
    loading: "Loading field notebooks...",
    activities: "Activities",
    validated: "Validated",
    lastActivity: "Last Activity",
    noActivitiesYet: "No activities recorded yet",
    openNotebook: "Open Field Notebook",
    irrigation: "Irrigation",
    fertilization: "Fertilization",
    pestControl: "Pest Control",
    harvest: "Harvest",
    pruning: "Pruning",
    planting: "Planting",
    weeding: "Weeding",
    other: "Other"
  },
  pkPage: {
    title: "P&K Fertilizer Optimizer",
    subtitle: "Optimize phosphorus and potassium application based on NDVI zones and soil analysis",
    ndviBasedZones: "NDVI-Based Zones",
    ndviZonesDesc: "Variable rate application based on crop vigor",
    scientificRatios: "Scientific Ratios",
    scientificRatiosDesc: "UC Davis, FAO & IPNI validated formulas",
    costSavings: "Cost Savings",
    costSavingsDesc: "Reduce fertilizer waste by 10-25%",
    selectParcel: "Select Parcel",
    selectParcelDesc: "Choose the parcel you want to optimize fertilization for",
    noParcelsFound: "No parcels found. Please add a parcel first to use the P&K Optimizer."
  },
  pestPage: {
    title: "Pest & Disease Management",
    subtitle: "Monitor crop health, risk signals and field observations for agronomist review.",
    noParcelsFound: "No Parcels Found",
    noParcelsDesc: "Please add a parcel first to monitor pests & diseases",
    ruleBasedBadge: "Rule-based",
    weatherBasedBadge: "Weather-based",
    satelliteObservedBadge: "Satellite-observed",
    dataLimitedBadge: "Data limited",
    betaBadge: "Beta",
    scoutingAvailableBadge: "Scouting input available",
    noScoutingBadge: "No scouting data",
    disclaimerRuleBased: "Disease-risk models are currently rule-based and should be validated with field scouting before any intervention decision.",
    relatedModulesHint: "Separate standalone modules — complementary to the contextual views above.",
    openIrrigationReports: "Open Irrigation Reports",
    openHarvestEstimator: "Open Harvest Value Estimator",
    flow: {
      tabSummary: "Summary",
      tabEvidence: "Evidence",
      tabZones: "Risk zones",
      tabAction: "Action plan",
      stepSummary: "Risk status",
      stepEvidence: "Evidence",
      stepZones: "Zones",
      stepAction: "Action",
      subtitleSummary: "A compact view of current pest and disease risk, confidence and next action for this parcel.",
      subtitleEvidence: "Signals used, missing data and confidence behind the current risk assessment. This view explains the evidence behind the assessment. It does not suggest interventions by itself.",
      subtitleZones: "Where risk signals or low-vigor zones appear within the parcel.",
      subtitleAction: "Suggested next step and priority area for review. Review support only — not a product prescription.",
      noPriorityZonesEmpty: "No priority zones detected with the current signals.",
      ctaEvidence: "See evidence",
      ctaZones: "See risk zones",
      ctaAction: "Go to action plan"
    },
    tabHealth: "Crop Health",
    tabRiskMap: "Risk Map",
    tabDiseaseModels: "Disease Risk Models",
    tabOverview: "Overview",
    tabImageDiagnosis: "Image Diagnosis",
    tabScouting: "Scouting Records",
    aiAssistedBetaBadge: "AI-assisted · Beta",
    relatedModules: "Related modules",
    viewIrrigation: "View irrigation status",
    viewHarvest: "View harvest forecast",
    scoutingTitle: "Scouting Records",
    scoutingComingSoon: "Field scouting log coming soon. Use the Field Notebook to record observations in the meantime.",
    openFieldNotebook: "Open Field Notebook",
    tabRiskIntelligence: "Risk Intelligence",
    riskIntel: {
      heading: "Risk Intelligence",
      subheading: "Can I trust this risk result, and what data is missing?",
      modelStatusTitle: "Model status",
      modelStatusBody: "Current risk signals are rule-based and weather-based.",
      signalsUsedTitle: "Signals used",
      signalCrop: "Crop type",
      signalWeather: "Weather conditions",
      signalDb: "Pest/disease database",
      signalSatellite: "Satellite vegetation context",
      signalGdd: "GDD (Growing Degree Days)",
      signalScouting: "Field scouting",
      ifAvailable: "if available",
      available: "Available",
      missing: "Missing",
      missingSignalsTitle: "Missing signals",
      missingNoGdd: "No GDD available",
      missingNoScouting: "No scouting records",
      missingNoDiagnosis: "No confirmed field diagnosis",
      missingNoPhenology: "No phenology / crop stage signal",
      noneMissing: "All core signals available",
      confidenceTitle: "Confidence",
      confHigh: "High",
      confMedium: "Medium",
      confLow: "Low",
      confDataLimited: "Data limited",
      confidenceHint: "Computed from available signals — not invented.",
      validationWarning: "Use this as review support. Validate with field scouting before any intervention decision.",
      ctaViewMap: "View current risk map",
      gddAvailable: "Available",
      gddMissing: "Missing",
      gddCurrentLabel: "Current GDD",
      gddWeatherDerivedBadge: "Weather-derived",
      gddEnableHint: "Run or enable GDD calculation for this parcel to improve pest/disease risk confidence."
    },
    tabTreatmentSupport: "Phytosanitary review support",
    treatmentSupport: {
      heading: "Phytosanitary review support",
      subheading: "What should I do next: monitor, scout, or request an agronomist review?",
      disclaimer: "This is a review-support view. Validate with field scouting and agronomic judgment before any intervention decision.",
      card1Title: "Current risk status",
      noRiskSignal: "No high pest or disease risk detected",
      mainRiskLevel: "Main risk level",
      mainSignal: "Main signal",
      confidence: "Confidence",
      gddStatus: "GDD",
      scoutingStatus: "Scouting",
      scoutingConfirms: "Issue reported in field",
      scoutingNoIssue: "No issue reported",
      scoutingMissing: "No scouting records",
      scoutingMissingHint: "Create a scouting record to increase confidence before any intervention decision.",
      risk_high: "High",
      risk_medium: "Medium",
      risk_low: "Low",
      risk_none: "No data",
      card2Title: "Suggested next action",
      decisionSupportNote: "Review support only — not a phytosanitary diagnosis or product prescription.",
      actionConsiderTitle: "Request an agronomist review of the affected zones.",
      actionConsiderBody: "High risk is detected and field scouting reports an issue. Consider a targeted intervention in priority zones, validated by an agronomist.",
      actionConsiderLabel: "Request agronomist review",
      actionScoutTitle: "Scout high-priority zones before any intervention decision.",
      actionScoutBody: "High risk is detected but no scouting confirmation exists. Inspect priority zones in the field before any decision.",
      actionScoutLabel: "Scout",
      actionMonitorScoutTitle: "Monitor and schedule scouting.",
      actionMonitorScoutBody: "Medium risk detected. Keep monitoring and plan a scouting visit.",
      actionMonitorScoutLabel: "Monitor / Scout",
      actionMonitorTitle: "No immediate intervention is required based on available evidence. Continue monitoring.",
      actionMonitorBody: "Risk signals are low. Continue routine monitoring.",
      actionMonitorLabel: "Continue monitoring",
      card3Title: "Zone prioritization",
      noZones: "No zone-level review support available yet. Generate NDVI/vegetation zones from Satellite Intelligence or Nitrogen Optimizer first.",
      noPriorityZones: "No low-vigor or anomalous zones detected in the latest analysis.",
      reasonLowVigor: "low vigor",
      card4Title: "Priority area for review",
      noReductionEstimate: "This estimate becomes available once vegetation zones and parcel area are available.",
      totalArea: "Total area",
      priorityArea: "Priority area",
      avoidedArea: "Avoided area",
      avoidedPercent: "Reduction",
      reductionNote: "Priority-area-for-review estimate, not a confirmed product reduction.",
      ctaOpenRiskMap: "Open Risk Map",
      ctaOpenNotebook: "Open Field Notebook / Add scouting record",
      // V1 Targeted Treatment Support additions
      dataDependentBadge: "Data-dependent",
      fieldValidationBadge: "Field validation required",
      noPrescriptionBadge: "No pesticide prescription",
      mandatoryDisclaimer: "Review support only. Sentinel Crop does not prescribe pesticides, products or doses. Final intervention decisions must be validated by a qualified agronomist and the product label.",
      priorityScoreTitle: "Review priority",
      priorityScoreSuffix: "/100",
      waterStressCheckTitle: "Water-stress check",
      waterStressStrong: "Strong water-stress signal detected. Priority lowered — review irrigation before any intervention decision.",
      waterStressPartial: "Partial water-stress signal detected. Priority slightly adjusted; field scouting required.",
      waterStressNone: "No significant water-stress signal in the available indicators.",
      waterStressUnknown: "Water-stress indicators are not available for this parcel.",
      waterStressSignalsTitle: "Signals considered",
      waterStressSignalNdwi: "NDWI",
      waterStressSignalNdmi: "NDMI",
      waterStressSignalBalance: "FAO-56 water balance",
      waterStressSignalRain: "Rainfall deficit",
      waterStressSignalAlert: "Water-stress alert",
      waterStressNotAvailable: "Not available",
      scoutingRequiredTitle: "Scouting required",
      scoutingRequiredBody: "Without a recent scouting report or field evidence, the system cannot suggest any intervention as a direct action. The maximum allowed suggestion is: \"Request agronomist review after field validation\".",
      whyTitle: "Why this recommendation?",
      driverLocalNdvi: "localized NDVI decline",
      driverRapidDecline: "rapid NDVI decline",
      driverDiseaseWeather: "disease-conducive weather",
      driverPestWindow: "active pest/disease risk window",
      driverPhenology: "sensitive phenological stage",
      noDriversDetected: "No strong drivers detected in the available signals.",
      actionReviewIrrigationLabel: "Review irrigation first",
      actionReviewIrrigationTitle: "Review irrigation status and scout before any intervention decision.",
      actionReviewIrrigationBody: "Water-stress indicators dominate the current anomaly. Verify irrigation status and perform a scouting visit before any intervention decision.",
      actionConsiderAfterValidationLabel: "Request agronomist review after field validation",
      actionConsiderAfterValidationTitle: "Request agronomist review after field validation.",
      actionConsiderAfterValidationBody: "Risk signals and field scouting align. Priority zones can be reviewed by an agronomist after field validation. Sentinel Crop does not prescribe products or doses.",
      reportReadyTitle: "Report-ready explanation",
      reportReadyCopy: "Copy",
      reportReadyCopied: "Copied",
      reportReadyNotAutoAdded: "This is a report-ready summary you can copy into Field Notebook, advisor notes or an external report. It is not automatically added to Reports Center yet.",
      // Explanation builder strings
      expLead: "Sentinel Crop identified {{zones}} priority zone(s) representing {{priorityHa}} ha of the {{totalHa}} ha parcel.",
      expDrivenBy: "The signal is driven by",
      expWaterStrong: "Water-stress indicators largely explain the anomaly, so irrigation review and field scouting are required before any intervention decision.",
      expWaterPartial: "Water-stress indicators explain part of the anomaly, so field scouting is required before any intervention decision.",
      expWaterNone: "Water-stress indicators do not explain the anomaly.",
      expWaterUnknown: "Water-stress indicators are not available for this parcel; treat the conclusion with caution.",
      expScoutingRequired: "Field scouting is required before any intervention decision.",
      expScoutingPresent: "Field scouting confirms an issue on the parcel.",
      expReduction: "Estimated reduction of the area to review versus reviewing the whole parcel: {{pct}}%.",
      expReductionUnavailable: "The reduction of the area to review cannot be estimated with the current data.",
      expLimitations: "Data limitations: {{items}}.",
      expNoPriority: "No priority zones detected with the current signals. Continue routine monitoring.",
      limNoNdviHistory: "no NDVI history",
      limNoWaterIndices: "no NDWI/NDMI",
      limNoWaterBalance: "no FAO-56 balance",
      limNoScouting: "no scouting record",
      limNoZoneArea: "zone-area approximated",
      limNoParcelArea: "no parcel area",
      limNoGdd: "no GDD"
    }
  },
  cropResourcesPage: {
    title: "Crop Knowledge Base",
    subtitle: "Comprehensive agricultural reference guide for crop planning and management",
    comparativeTable: "Comparative Table",
    cropVarieties: "Crop Varieties",
    plantingSeasons: "Planting Seasons",
    growthStages: "Growth Stages",
    cropComparison: "📊 Crop Comparison Summary",
    cropComparisonDesc: "Key agronomic parameters for major crops",
    crop: "Crop",
    totalCycle: "Total Cycle",
    phases: "Phases",
    baseTemp: "Base Temp",
    kcMax: "Kc Max",
    gddTotal: "GDD Total",
    type: "Type",
    perennial: "Perennial",
    annual: "Annual",
    varieties: "varieties",
    varietiesDesc: "Common commercial varieties with characteristics and regional adaptation",
    typicalYield: "Typical Yield:",
    mainRegions: "Main Regions:",
    europePlanting: "Europe - Planting & Harvest",
    latamPlanting: "Latin America - Planting & Harvest",
    planting: "Planting",
    harvest: "Harvest",
    daysCycle: "days cycle",
    days: "days"
  },
  fertilizationPage: {
    title: "Fertilization Management",
    nutrientWizard: "Nutrient Balance Wizard",
    selectParcel: "Select Parcel",
    selectParcelPlaceholder: "Select a parcel",
    noCrop: "No crop",
    nutrientBalanceCalculated: "Nutrient Balance Calculated",
    nutrientBalanceApplied: "Nutrient Balance Applied",
    targetYield: "target",
    nitrogenVRA: "Nitrogen (N) VRA",
    pkOptimizer: "P&K Optimizer"
  },
  traceabilityPage: {
    title: "Blockchain Traceability",
    subtitle: "Create and manage blockchain-tracked product batches with full supply chain transparency",
    productBatches: "Product Batches",
    qrCodes: "QR Codes",
    qrComingSoon: "QR Code management coming soon..."
  },
  paymentCancelled: {
    title: "Payment Cancelled",
    subtitle: "Your insurance policy purchase was not completed",
    whatHappened: "What happened?",
    cancelledExplanation: "The payment process was cancelled. This can happen for several reasons:",
    reason1: "You cancelled the payment on the Stripe page",
    reason2: "There was a problem with your payment method",
    reason3: "The payment session expired due to inactivity",
    protectionAwaits: "Your Agricultural Protection Awaits You",
    tryAgainMessage: "Don't worry, you can try again when you're ready. Your policy configuration will be saved.",
    benefitsTitle: "Benefits of protecting your crops:",
    benefit1: "Protection against droughts and extreme weather events",
    benefit2: "Automatic payments based on satellite data",
    benefit3: "24/7 monitoring of your parcels",
    benefit4: "No manual inspections or paperwork",
    backToDashboard: "Back to Dashboard",
    tryAgain: "Try Again"
  },
  paymentSuccess: {
    title: "Policy Activated!",
    subtitle: "Your agricultural insurance policy is now active",
    policyNumber: "Policy Number",
    startDate: "Start Date",
    coverageType: "Coverage Type",
    status: "Status",
    nextSteps: "Next Steps",
    step1: "Check your email for the confirmation",
    step2: "Configure alerts for your covered parcels",
    step3: "View your policy in the Insurance dashboard",
    goToDashboard: "Go to Dashboard",
    viewInsurance: "View Insurance"
  },
  missionControl: {
    title: "Mission Control",
    subtitle: "Your daily tasks and critical alerts at a glance",
    pendingTasks: "Pending Tasks",
    activeAlerts: "Active Alerts",
    completedToday: "Completed Today",
    overdueTasks: "Overdue Tasks",
    todaysTasks: "Today's Tasks",
    noTasksToday: "No tasks scheduled for today",
    criticalAlerts: "Critical Alerts",
    noActiveAlerts: "No active alerts — all parcels look healthy",
    markComplete: "Mark Complete",
    viewParcel: "View Parcel",
    dismiss: "Dismiss"
  },
  phenologyIntel: {
    title: "Phenology Intelligence",
    subtitle: "Crop-stage intelligence for irrigation, pest risk, fertilization and harvest decisions.",
    selectParcel: "Select parcel",
    selectParcelPlaceholder: "Choose a parcel",
    loading: "Loading parcels...",
    noParcels: "No parcels found.",
    currentStage: "Current stage",
    cumulativeGdd: "Cumulative GDD",
    lastObservation: "Last observation",
    daysAheadBehind: "Days ahead/behind",
    notAvailable: "Not available",
    noStage: "No phenological stage is available for this parcel yet. Add a field observation or run GDD calculation if available.",
    noCropConfig: "Phenology configuration is not available for this crop yet.",
    recordObservation: "Record observation",
    recordObservationHint: "User-observed stage corrects and validates the stage used by downstream engines.",
    selectStagePlaceholder: "Select a stage",
    notesPlaceholder: "Optional notes...",
    saveObservation: "Save observation",
    saving: "Saving...",
    selectStageError: "Please select a parcel and stage.",
    observationSaved: "Observation saved",
    updateFailed: "Update failed",
    recommendedActions: "Recommended next actions",
    footer: "Phenology estimates are decision-support signals. They may be based on user observations, GDD calculations and crop-stage configuration when available. Validate with field observations before operational decisions.",
    badges: {
      decisionSupport: "Decision-support",
      dataDependent: "Data-dependent",
    },
    source: {
      user_observed: "User-observed",
      gdd_estimated: "GDD-estimated",
      none: "Not available",
    },
    confidence: {
      high: "High confidence",
      medium: "Medium confidence",
      low: "Low confidence",
      data_limited: "Data limited",
    },
    impacts: {
      irrigation: {
        title: "Irrigation sensitivity",
        body: "Current stage affects Kc and irrigation sensitivity.",
        latest: "Latest FAO-56 recommendation: {{date}}.",
        noResult: "No recent FAO-56/Kc result available.",
      },
      pest: {
        title: "Pest & disease window",
        body: "Stage influences the pest and disease risk window. Cross-check with the Risk Map and field scouting.",
        noConfig: "Stage-specific pest/disease window not configured for this crop. Use Risk Map and field scouting.",
      },
      fertilization: {
        title: "Fertilization timing",
        body: "Phenology helps contextualize nitrogen and fertilization timing.",
      },
      harvest: {
        title: "Harvest forecast",
        body: "Phenology is used to contextualize harvest readiness and forecast confidence.",
      },
    },
    actions: {
      addObservation: "Add a phenology observation to improve downstream recommendations.",
      runGdd: "Run or update GDD calculation for this parcel.",
      scheduleScouting: "Schedule field scouting to validate stage-sensitive risks.",
    },
    ctas: {
      openIrrigation: "Open Irrigation",
      openPestDiseases: "Open Pest & Disease",
      openNitrogen: "Open Nitrogen Optimizer",
      openHarvest: "Open Harvest Forecast",
      fieldNotebook: "Open Field Notebook",
    },
  }
};
